class FlavorSamplerSlider {
  constructor(container) {
    if (!container || typeof Swiper === 'undefined') {
      if (typeof Swiper === 'undefined') {
        console.error('Swiper.js is required but not loaded.');
      }
      return;
    }

    this.container = container;
    this.swiperContainer = this.container.querySelector('.flavor-sampler__carousel');
    this.track = this.container.querySelector('[data-flavor-slider]');
    this.prevButton = this.container.querySelector('[data-flavor-button="prev"]');
    this.nextButton = this.container.querySelector('[data-flavor-button="next"]');

    this.autoplayEnabled = this.container.dataset.autoplay === 'true';
    
    const speedSeconds = parseFloat(this.container.dataset.speed);
    this.autoplaySpeed = (isNaN(speedSeconds) || speedSeconds < 3) ? 4000 : Math.round(speedSeconds * 1000);
    
    this.initSwiper();
  }

  initSwiper() {
    const swiperOptions = {
      wrapperClass: 'flavor-sampler__track',
      slideClass: 'flavor-sampler__slide',

      slidesPerView: 'auto', 
      
      centeredSlides: true, 
      
      spaceBetween: 16, 
      breakpoints: {
        750: {
          spaceBetween: 32, 
        }
      },

      loop: true,
      
      autoplay: this.autoplayEnabled ? {
        delay: this.autoplaySpeed,
        disableOnInteraction: true, 
      } : false,

      navigation: {
        prevEl: this.prevButton,
        nextEl: this.nextButton,
        disabledClass: 'is-disabled' 
      },

      mousewheel: {
        sensitivity: 0.5, 
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      on: {
        init: () => {
          this.setActiveSlideClass();
        },
        slideChangeTransitionEnd: () => {
          this.setActiveSlideClass();
        },
      }
    };

    this.swiper = new Swiper(this.swiperContainer, swiperOptions);
  }
  
  setActiveSlideClass() {
    if (!this.swiper) return;

    this.swiper.slides.forEach(slide => slide.classList.remove('is-active'));
    
    const activeSlide = this.swiper.slides[this.swiper.activeIndex];
    if (activeSlide) {
      activeSlide.classList.add('is-active');
    }
  }
}

function initFlavorSamplers() {
  const sections = document.querySelectorAll('[data-section-type="flavor-sampler"]');
  sections.forEach(container => new FlavorSamplerSlider(container));
}

document.addEventListener('DOMContentLoaded', initFlavorSamplers);

document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId.includes('flavor-sampler')) {
    const container = event.target.querySelector('[data-section-type="flavor-sampler"]');
    new FlavorSamplerSlider(container);
  }
});